<template>
	<div class="jobList">
        <div class="o-main-content-area">
            <div class="table_header_wrapper sticky_header" style="top: 70px">
                <div class="row with-adjust-on-open-sidenav">
                    <div class="col-md-12 o-no-padding c-responsive-fixwidth">
                        <div class="col-md-3">
                            <h1 class="h1">
                                Jobs / Events
                            </h1>
                        </div>
                        <div class="col-md-9 text-right">
                            <ul class="o-filter-area">
                                <li class="o-search-field">
                                    <!-- #1711: this input had no v-model and no handler, and the
                                         button was a bare type="submit" -- the box has never searched
                                         anything. Now debounced onto the active tab's endpoint. -->
                                    <div class="input-group stylish-input-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Job name, venue, number, contact"
                                            v-model="searchData"
                                            @keyup="onSearchInput"
                                            @keyup.enter="runSearch"
                                        >
                                        <span class="input-group-addon">
                                            <button type="button" @click="runSearch">
                                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                            </button>
                                        </span>
                                    </div>
                                </li>
                                <li v-if="userRole !== 'employer-sheet-only'">
                                    <a href="javascript: void(0)" @click="openAddJob()" class="c-solid-btn c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i>
                                        Add New Job
                                    </a>
                                </li>
                               
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="c-common-space c-responsive-fixwidth with-adjust-on-open-sidenav">
                    <div class="col-md-12 o-tab-area o-no-padding">
                        <div class="col-md-6 o-no-padding">
                            <ul class="o-tab-view o-tab-view--text js-job-tab-select">
                                <li>
                                    <a href="javascript: void(0)" @click="myJob()" :class="(selectedTab.parent=='myJob')?'active':''">My Jobs by User</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="allJob()" :class="(selectedTab.parent=='allJob')?'active':''">All Jobs by Employer</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="c-common-space c-responsive-fixwidth with-adjust-on-open-sidenav">
                    <div class="col-md-12 o-no-padding">
                        <ul class="o-tab-view o-month-tab">
                            <li href="javascript: void(0)" @click="next45Days()" :class="(selectedTab.child=='next45')?'o-month-select':''"><a class="c-common-btn">Next 45 Days</a>
                            </li>

                            <li href="javascript: void(0)" @click="getIncompleteJobs()" :class="(selectedTab.child=='incomplete')?'o-month-select':''"><a class="c-common-btn">Incomplete Jobs</a>
                            </li>

                            <li href="javascript: void(0)" @click="getTodayJobs()" :class="(selectedTab.child=='today')?'o-month-select':''"><a class="c-common-btn">Today</a>
                            </li>

                            <li href="javascript: void(0)" @click="getTomorrowJobs()" :class="(selectedTab.child=='tomorrow')?'o-month-select':''"><a class="c-common-btn">Tomorrow</a>
                            </li>

                            <li href="javascript: void(0)" @click="getPrev()"> 
                                <i class="fa fa-arrow-circle-left btn-arraw-adjust" aria-hidden="true"></i>
                            </li>
                            <li :class="(selectedTab.child=='month')?'o-month-select':''">
                                <div class="block o-datepicker-input">
                                    <el-date-picker
                                    type="month"
                                    @change="monthChange()"
                                    v-model="monthSort"
                                    format="MMMM"
                                    placeholder="Month">
                                    </el-date-picker>
                                </div>
                            </li>
                            <li @click="getNext()">
                                    <i class="fa fa-arrow-circle-right btn-arraw-adjust" aria-hidden="true"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- /Days Filter -->
            </div>

            <div 
                v-loading="loading" v-if="(!jobList || jobList.length==0) && afterAPI == true" 
                class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3" 
                style="margin-top: 165px;"
            >
                <div class="col-md-12 no-job-dispaly">
                    <i class="fa fa-frown-o" aria-hidden="true"></i>
                    <br />
                    {{loading?'':'No Data Stored'}}
                </div>
            </div>
            
            <div 
                v-loading="loading" 
                class="c-common-space c-responsive-fixwidth"  
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10" 
                style="margin-top: 130px; min-height: 1px;"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
            >
                <div class="col-md-12 o-no-padding">

                    <div class="panel-group" id="accordion">

                        <div class="panel panel-default o-accordion-area c-common-box-shadow" v-for="(job,key) in jobList" :key="key">
                            <div class="panel-heading o-accordion-heading new-o-accordion-heading c-common-gradient">
                                <div @click="gotoJobDetails(job.id)" class="col-md-3 o-no-padding">
                                    <div class="new-o-accordion-title">
                                        <a href="javascript: void(0)" :class="(job.issues>0)?'new-admin-event-head':(job.calls_count==0)?'new-admin-event-head':'new-admin-event-head-green'"> Event: <span>{{job.title + ' - ' + job.job_number}}</span><br/> <span>- {{job && job.employer?job.client.subdomain:'--'}}</span></a>
                                    </div> 
                                </div>
                                <div @click="gotoJobDetails(job.id)" class="col-md-2 o-no-padding">
                                    <div class="new-o-accordion-title">
                                        <a href="javascript: void(0)" :class="(job.issues && job.issues>0)?'new-admin-event-head':(job.calls_count==0)?'new-admin-event-head':'new-admin-event-head-green'"><span>@ {{job && job.venue ? job.venue.name :'--'}}</span></a>
                                    </div> 
                                </div>
                                <div class="col-md-7 text-right new-left-right-padding">
                                    <ul class="o-job-accordio-header">
                                        <li class="joblist-dateField">
                                            <span class="o-accordion-head">Dates : </span>
                                            <div class="o-accordion-element">
                                                {{ getTitleDate(job.start)+' to '+getTitleDate(job.end)}}
                                            </div>
                                        </li>
                                        <li>
                                            <span class="o-accordion-head">Status:</span>
                                            <div class="o-accordion-element">
                                                {{job.status.name}}
                                            </div>
                                        </li>
                                        
                                        <li>                                            
                                            <div class="o-accordion-element"><span :class="(job.issues && job.issues>0)?'o-issue-counter':(job.calls_count==0)?'o-issue-counter':'o-issue-counter o-issue-counter-green'">
                                                {{job&&job.unassigned_calls_count?job.unassigned_calls_count:'0'}}/{{ job&&job.unconfirmed_calls_count?job.unconfirmed_calls_count:'0'}}/{{job&&job.calls_count?job.calls_count:'0'}}

                                            </span></div>
                                        </li>
                                        <li>
                                            <div class="o-accordion-element o-accordion-link">
                                                <router-link :to="'viewCallsEmployer/'+getId(job.id)" class="new-call-phone-btn">C</router-link>
                                                <router-link :to="'employerSignInSheet/'+getId(job.id)" class="new-call-phone-btn">S</router-link>
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="add-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button type="button" @click="closeAddJob()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">{{modalType=='add'?'Add New Job':'Edit Job'}}</h1>
                    </div>
                    <div v-loading="modalLoading" class="modal-body c-common-box-shadow o-modal-body">

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Event Name:<span class="req-text">*</span></label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input v-model="addJob.title" v-validate="'required'" name="event name" type="text" class="form-control" placeholder="Event Name">
                                        <span class="err-msg">{{ errors.first('event name') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Client:<span class="req-text">*</span></label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div class="row">
                                        <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                            <div class="common-label-input--modalwidth o-custom-dropdown">
                                                <select v-validate="'required'" name="client" class="form-control" v-model="addJob.client" :disabled="modalType=='edit'" @change="getDropdownVenues()">
                                                    <option value="">--- Select ---</option>
                                                    <!-- #1851 — selectability comes from the SERVER (`can_create_job`), which
                                                         resolves it with ClientEmployer::grantsJobCreation() — the same
                                                         place EnsureEmployerAccess resolves the level it gates on.

                                                         This used to be decided here, by comparing the status NAME against
                                                         one value: anything that was not 'View Access' enabled the option,
                                                         so 'Api Access' and 'No Access' BOTH enabled it and setting an
                                                         employer to No Access made the local MORE available than leaving
                                                         it blank. Adding a job is a write; create_edit is the only level
                                                         that enables it.

                                                         Compared with `=== true` so a payload without the field fails
                                                         CLOSED. An unknown grant is not a grant — the same doctrine
                                                         ClientEmployer applies to an unrecognised status id. -->
                                                    <option v-for="(client,clientIndex) in clients" :key="clientIndex" :value="client.client_id" :class="client.can_create_job === true ? '':'disabled-background-style'" :disabled="client.can_create_job !== true">{{client.client.subdomain.toUpperCase()}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                <span class="err-msg">{{ errors.first('client') }}</span>

                                            </div>
                                        </div>
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                        </div>
                                        <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                            <div class="common-label-input--modalwidth o-custom-dropdown">
                                                <select class="form-control" v-model="addJob.payroll">
                                                    <option value="">--- Select ---</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Employer Contact:<span class="req-text">*</span></label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                    <select class="form-control" v-model="addJob.employer_contact" name="employer contact">
                                        <option value="" disabled>Select Employer Contact</option>
                                        <option v-for="(user,idx) in employer_users" :key="idx" :value="user.user_id"> {{ getEmployerFullName(user.user) }}</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </div>
                                
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Venue:<span class="req-text">*</span></label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <el-select v-model="addJob.venue" filterable placeholder="Select Venue" style="width: 100%;">
                                            <el-option
                                            v-for="venue in venues"
                                            :key="venue.id"
                                            :label="venue.name"
                                            v-validate="'required'"
                                            :value="venue.id">
                                            </el-option>
                                            <span class="err-msg">{{ errors.first('venue') }}</span>
                                        </el-select>                                        
                                    </div>                                
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Start Date:<span class="req-text">*</span></label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div class="row">
                                        <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                            <el-col :span="50">
                                                <el-date-picker
                                                type="date"
                                                :placeholder="getDatePlaceholder()"
                                                style="width: 100%;"
                                                v-validate="'required'"
                                                name="start"
                                                v-model="addJob.start"
                                                :format="getDisplayFormat()"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                >
                                                </el-date-picker>
                                                <span class="err-msg">{{ errors.first('start') }}</span>
                                            </el-col>
                                            </label>
                                            
                                        </div>
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">End Date:<span class="req-text">*</span></label>
                                        </div>
                                        <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                            <el-col :span="50">
                                                <el-date-picker
                                                type="date"
                                                :placeholder="getDatePlaceholder()"
                                                style="width: 100%;"
                                                v-validate="'required'"
                                                name="end"
                                                v-model="addJob.end"
                                                :format="getDisplayFormat()"
                                                :picker-options="pickerOptions"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                >
                                                </el-date-picker>
                                                <span class="err-msg">{{ errors.first('end') }}</span>
                                            </el-col>  
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                    <!-- <vue-editor id="editor1" class="c-common-box-shadow c-radius3" v-model="addJob.employer_request" style="height: 220px;"></vue-editor> -->

                                    <vue-editor 
                                        id="editor1" 
                                        class="c-common-box-shadow c-radius3" 
                                        :class="{ 'error-border': hasError }"
                                        v-model="addJob.employer_request" 
                                        style="height: 220px;"
                                        @text-change="validateContent('employer_requests', addJob.employer_request)"
                                    ></vue-editor>
                                    <span 
                                        v-if="error.employer_requests && error.employer_requests.hasError" 
                                        class="err-msg"
                                    >
                                        {{ error.employer_requests.message }}
                                    </span>



                                </div>
                            </div>
                        </div>

                        <div v-if="modalType=='add'" class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Documents:</label>
                            </div>
                            <div class="col-sm-8 o-left-no-padding o-modal-form-field no-right-padding">
                                <div v-for="(file, key) in new_files" :key="key" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                    <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                    <input @change="addFileForAddNewJob($event,key)" type="file" name="myfile" />
                                    <span class="addJobTypeArea">
                                        <span class="addJob-title">{{snippet(new_files[key].name)}}</span>
                                        <span v-if="file.selected == true" class="addJob-drop">
                                            <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop add-job-drop-type">
                                                <select v-model="new_files[key].label">
                                                    <option value="Report">Report</option>
                                                    <option value="HW">HW</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        </span>
                                    </span>
                                    <a href="javascript: void(0)" v-if="new_files.length >1" @click="removeFile(key)" class="o-choose-del-btn">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-sm-1 o-right-no-padding o-modal-form-field o-job-add-icon">
                                <label class="common-label-text common-label-text--modalwidth">
                                    <a href="javascript: void(0)" @click="cloneInputfile()" class="o-choose-add-btn">
                                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                    </a>
                                </label>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeAddJob()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" v-if="modalType=='add'" @click="addNewJob()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Job</a>
                                <a href="javascript: void(0)" v-if="modalType=='edit'" @click="editJob()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</a>
                            </li>
                        </ul>
                    </div>
                </div>    
                </div>
            </div>
        </modal>
	</div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import { VueEditor } from 'vue2-editor';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';

    export default {
        computed: {
            ...mapGetters({
               	userToken: 'userToken',
		        userRole: 'userRole',
		        companyId: 'companyId',
		        loginUserName: 'userName',
		        userID: 'userID',
		        userName: 'userName',
		        userFullName: 'userFullName',
                userRoleSlug: 'userRoleSlug'
            })
        },
        components: {
            VueEditor
        },
        data() {
            const dataProps = {
                // #1711: the Job Search box. searchTimer debounces keystrokes so a
                // fast typist does not fire one request per character -- these list
                // endpoints pull every matching row and paginate in PHP.
                searchData: '',
                searchTimer: null,
                loading:false,
                jobList: null,
                editJobId:'',
                monthSort: new Date(),
                modalLoading:false,
                modalType:'add',
                selectedTab:{
                    parent:'allJob',
                    child:'next45'
                },
                venues:[],
                newJobId:'',
                next_page: "",
                storeMore: [],
                clients:{},
                afterAPI:false,
                addJob:{
                  title:'',
                  client:'',
                  payroll:'',
                  employer_contact:'',
                  start:'',
                  end:'',
                  employer_request:'',
                  venue: ''
                },

                validation_err: 0,
                
                files: [{
                    file: 'No file chosen'
                }, ],
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
   
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: new Date(dataProps.addJob.start).setDate(new Date(dataProps.addJob.start).getDate() - 1)
                    };
                },
                employer_users: [],
                hasError: false,
                error: {},

            }
            return dataProps;
        },
        
        created() {},

        methods: {
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            getNext(){
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }else{
                    this.monthSort=moment(this.monthSort).add(1, 'M').format('YYYY-MM-DD HH:mm:ss');
                }
                this.selectedTab.child='month';

                this.getJob();
            },
            getPrev(){
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }else{
                    this.monthSort=moment(this.monthSort).subtract(1, 'M').format('YYYY-MM-DD HH:mm:ss');
                }
                this.selectedTab.child='month';
                this.getJob();
            },
            monthChange(){
                this.selectedTab.child='month';
                this.getJob();
            },
            myJob(){
                this.selectedTab={
                    parent:'myJob',
                    child:'next45'
                }
                this.getJob();
            },
            allJob(){
                this.selectedTab={
                    parent:'allJob',
                    child:'next45'
                }
                this.getJob();
            },
            next45Days(){
                this.selectedTab.child='next45';
                this.getJob();
            },
            getIncompleteJobs(){
                this.selectedTab.child='incomplete';
                this.getJob();
            },
            getTodayJobs(){
                this.selectedTab.child='today';
                this.getJob();
            },
            getTomorrowJobs(){
                this.selectedTab.child='tomorrow';
                this.getJob();
            },
            /**
             * #1711 — debounced search. 400ms after the last keystroke the active
             * tab refetches; getJob() already resets jobList / storeMore / next_page,
             * so no extra teardown is needed here.
             */
            onSearchInput() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                }
                this.searchTimer = setTimeout(this.runSearch, 400);
            },

            runSearch() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                    this.searchTimer = null;
                }
                this.getJob();
            },

            getJob(){
                this.jobList = null;
                this.storeMore = [];
                this.next_page='';
                console.log(this.selectedTab);
                if(this.selectedTab.parent=="myJob"){
                    switch(this.selectedTab.child){
                        case "next45":
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerMyJobsNext45Days', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;

                        case 'incomplete':
                            console.log('my-job incomplete')
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/employerMyincompleteJobs', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        
                        case 'today': 
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllMyJobsToday', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        case 'tomorrow': 
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllMyJobsTomorrow', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        case 'month':
                            //console.log('myJob month');
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerMyJobsByMonth', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                                'month': moment(this.monthSort).month()+1,
                                'year': moment(this.monthSort).year()
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                      'month': moment(this.monthSort).month()+1,
                                      'year': moment(this.monthSort).year()
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                    }
                }else{
                    switch(this.selectedTab.child){
                        case 'next45':
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllJobsNext45Days', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;

                        case 'incomplete': 
                            console.log('incomplete');
                            console.log('my-job incomplete')
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/employerAllincompleteJobs', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        
                        case 'today': 
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllJobsToday', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        case 'tomorrow': 
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllJobsTomorrow', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                        
                        case 'month':
                            this.loading = true;
                            this.afterAPI = false;
                            service.get('employerjob/getEmployerAllJobsByMonth', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'user-id': this.userID,
                                'search': this.searchData,
                                'month': moment(this.monthSort).month()+1,
                                'year': moment(this.monthSort).year()
                            }).then((res) => {
                                this.jobList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                                this.loading = false;
                                this.afterAPI = true;
                                if (this.next_page != null) {
                                  service.getUrl(this.next_page, {
                                      'Authorization': this.userToken,
                                      'cs3-context-role': this.userRole,
                                      'cs3-context-clientId': this.userClientID,
                                      'employer-id': this.companyId,
                                      'user-id': this.userID,
                                      'search': this.searchData,
                                      'month': moment(this.monthSort).month()+1,
                                      'year': moment(this.monthSort).year()
                                  })
                                  .then((res) => {
                                      this.storeMore = res.data.result.data;
                                      this.next_page = res.data.result.next_page_url;

                                  }).catch((err) => {
                                      console.log(err);
                                  })
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.afterAPI = true;
                                this.loading = false;
                            });
                            break;
                    }
                }
            },
            getId(id){
                return btoa(id);
            },
            
            getDate(str) {
                return dateTimeConvert.localDate(str);
            },

            async handleScroll(position) {
                if (position !== "bottom") return;
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.jobList;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore=[];
                    if (this.next_page != null) {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'employer-id': this.companyId,
                            'user-id': this.userID,
                            'search': this.searchData,
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                        }).catch((err) => {
                            console.log(err);
                        })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            gotoJobDetails(id){
              this.$router.push({
                  path: `/employerJobDetails/`+btoa(id)
              });
            },
            closeAddJob() {

                this.$modal.hide("add-job");
            },
            async addNewJob(){
                await this.$validator.validateAll().then((result) => {
                if (result) {
                    this.validateContent('employer_requests', this.addJob.employer_request);
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return; // Stop the save process
                    }
                    let fromData = {
                        title: this.addJob.title,
                        client_id: this.addJob.client,
                        payroll_id: this.addJob.payroll,
                        created_by: this.addJob.created_by,
                        start: this.addJob.start,
                        end: this.addJob.end,
                        venue_id: this.addJob.venue,
                        employer_requests: this.addJob.employer_request,
                        employer_contact: this.addJob.employer_contact
                    };

                    service.post('employerjob', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                    }).then((res) => {
                        this.newJobId=res.data.result.id;
                        this.uploadImage();
                        this.$modal.hide("add-job");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Job Added Successfully.',
                            type: 'success'
                        });
                        this.getJob();
                    }).catch((err) => {
                        console.log(err);
                    });
                }else{

                }
              });
            },
            async getDropdownVenues() {
                if(this.userRoleSlug == 'employer' || this.userRoleSlug == 'employer-admin') {
                    console.log("welcome");
                    await service.get('getVenuesList', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                        'cs3-context-clientId': this.addJob.client
                    })
                    .then((venues) => {
                        let resVenues = venues.data.result;
                        let venuesList = [];
                        resVenues.forEach((obj) => {
                            if(obj.addresses&&obj.addresses.length) {
                                venuesList.push(obj);
                            }
                        })
                        this.venues = venuesList;
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            async openAddJob() {
                this.modalType='add';
                this.modalLoading=true;
                this.$modal.show("add-job");
                this.addJob.created_by=this.userID;
                this.addJob.venue = '',
                this.addJob.client = '',
                await service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                })
                .then((res) => {
                    this.clients = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                await this.addEmployerContact(this.companyId);
                this.modalLoading=false;
            },
            editJob(){
              this.$validator.validateAll().then((result) => {
                if (result) {
                  let fromData = {
                    title: this.addJob.title,
                    client_id: this.addJob.client,
                    payroll_id: this.addJob.payroll,
                    created_by: this.addJob.created_by,
                    start: this.addJob.start,
                    end: this.addJob.end,
                    venue_id: this.addJob.venue,
                    employer_requests: this.addJob.employer_request,
                  };

                  service.put('employerjob/'+this.editJobId, fromData, {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'employer-id': this.companyId,
                  }).then((res) => {
                      this.$modal.hide("add-job");
                      this.$notify({
                          title: this.$t('success'),
                          message: 'Job Updated Successfully.',
                          type: 'success'
                      });
                      this.getJob();
                  }).catch((err) => {
                      console.log(err);
                  });
                }else{
                  console.log('error');
                }
              });    
            },
            async openEditJob(job) {
                this.modalType='edit';
                this.$modal.show("add-job");
                this.modalLoading=true;
                this.editJobId=job.id;
                this.addJob.title=job.title;
                this.addJob.client=job.client_id;
                this.addJob.payroll='';
                this.addJob.created_by=job.created_by;
                this.addJob.start=job.start;
                this.addJob.end=job.end;
                this.addJob.venue=job.venue_id;
                this.addJob.employer_request=job.employer_requests;
                await service.get('getVenuesList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId,
                    'cs3-context-clientId': this.addJob.client
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;                    
                    this.modalLoading=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalLoading=false;
                });
                await service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                })
                .then((res) => {
                    this.clients = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                await this.addEmployerContact(this.companyId);
            },
            async addEmployerContact(id) {
                await service.get('employer/'+id+'/getAllEmployerUsersListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    let self =this;                    
                    this.employer_users=res.data.result.employer_users;
                    this.employer_users.forEach(function(user) {
                        if(user.user_id == self.userID){
                            self.addJob.employer_contact = user.user_id;                            
                        }
                    });
                }).catch((err) => {
                    console.log(err);
                })
            },
            getEmployerFullName(user) {
                return user.first_name + ' ' + user.last_name
            },
            addFileForAddNewJob(e, index) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },
            uploadImage() {
                for (var i = 0; i < this.new_files.length; i++) {
                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false && this.new_files[i].selected==true) {
                        this.uploadService(this.new_files[i]).then((path) => {
                            //console.log(path);
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
            },
            uploadService(img) {
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name

                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.uploaded = true;

                            let activityData = {
                                uploader_id: this.userID,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.newJobId,
                                created_by: this.userID,
                                attachable_type: 'job',
                                filename: img.name,
                                description: 'Job Document',
                                label: img.label,
                                path: img.path,
                                activity: JSON.stringify(activityData)
                            }
                            service.post('attachment', fromData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID
                            })
                            .then((res) => {

                            }).catch((err) => {
                                 console.log('Error');
                            });

                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            
            cloneInputfile() {
                this.new_files.push({
                    'name': 'No file chosen',
                    'selected': false,
                });
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            removeFile(key) {
                this.new_files.splice(key, 1);
            },
            snippet(value) {
                if (value.length > 15)
                    return value.slice(0, 15) + '  ...';
                else
                    return value;
            },
            getTitleDate(dateTime) {
                return moment.utc(dateTime).format('MM-DD-YYYY');
            },

            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    if (this.containsInvalidContent(plainText)) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            message: 'Content contains invalid text. Please review and correct.'
                        });
                    }
                }
            },
    
            getPlainText(html) {
                // Remove HTML tags and get plain text
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent || div.innerText || '';
            },
    
            containsInvalidContent(text) {
                                
                // Example 1: Check for script tags or malicious content
                const scriptPattern = /<script|javascript:|onerror=|onclick=/i;
                
                // Example 2: Check for excessive special characters
                const excessiveSpecialChars = /[.?!,#$^&*()@%|"':;<>]{3,}/;
                
                // Example 3: Check for spam-like patterns (multiple repeated characters)
                const spamPattern = /(.)\1{3,}/;
                
                // Example 4: Check for invalid URLs or suspicious links
                const suspiciousUrl = /bit\.ly|tinyurl|goo\.gl/i;
                
                // Return true if any invalid pattern is found
                return scriptPattern.test(text) || 
                excessiveSpecialChars.test(text) || 
                spamPattern.test(text) ||
                suspiciousUrl.test(text);
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
            
        },
        mounted() {
            var sidenavWidth = $(".mainSidenav").width();
            var windowWidth = $(window).width();
            $(".o-header").css('width', windowWidth - sidenavWidth);
            this.getJob();
            setTimeout(()=>{
                var con = $('.o-sidenav.mainSidenav').hasClass('open');
                var windowWidth= $(window).width();
                var wrap = $('.table_header_wrapper.sticky_header');
                var c = 'animate_header';

                var temp = con ? wrap.addClass(c) : wrap.removeClass(c);
                
                if(con){
                  var myWidth=windowWidth-260;
                  $('.with-adjust-on-open-sidenav').css('width', myWidth);
                }else{
                  var myWidth=windowWidth-100;
                  $('.with-adjust-on-open-sidenav').css('width', myWidth);
                }  
            }, 1000);            
        }
    }

</script>
<style scoped>
  
.disabled-background-style {
    background-color: #bbb;
}
.modal-body {
    margin: 0px 15px;
}

.err-msg {
    margin: 2px;
    color: red
}

.status_message {
    margin: 15px 220px
}

.c-common-btn {
    cursor: pointer;
}

a {
    cursor: pointer;
}
sup{
        color: red;
}
.new-call-phone-btn{
    background-color: #ffffff;
    padding: 5px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 16px;
    border: 1px solid;
}
.new-admin-event-head{
    background-color: #FB8B03;
    padding: 0px 10px;
    border-radius: 16px;
    display: inline-block !important;
    color: #fff !important;
}
.new-admin-event-head-green{
    background-color: #0c8a2d;
    padding: 0px 10px;
    border-radius: 16px;
    display: inline-block !important;
    color: #fff !important;
}
.new-o-accordion-title a {
    font-size: 16px;
    font-weight: 500;
    line-height: 25px;
    width: 100%;
    
}
.new-o-accordion-title{
    padding-right: 5px;
}
.new-o-accordion-heading{
    padding: 10px 0px 10px 5px;
}
.o-job-accordio-header li {
    padding-right: 5px;
    padding-left: 5px;
}
.o-issue-counter 
{
    width: 69px;
}
.btn-arraw-adjust{
    font-size: 30px;
    padding: 5px 0px 0px 0px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: unset;
}
.sticky_header {
    position: fixed;
    right: 0;
    left: 0;
    min-width: 100%;
    padding: 10px 30px 0px 90px;
    z-index: 1;
}
.c-common-space {
    margin-top: 5px;
    margin-bottom: 5px;
    /* overflow: hidden; */
}
</style>
